import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, Users, BarChart, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function BusinessAccountPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="pt-32 pb-20 px-4 md:px-8 bg-gradient-to-br from-indigo-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <Building2 className="w-16 h-16 text-brand-blue mx-auto mb-6" />
          <h1 className="text-5xl md:text-7xl font-bold font-heading text-slate-900 mb-6">
            Business Accounts
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Banking solutions designed for Nigerian businesses. From startups to enterprises, manage your finances with ease.
          </p>
        </div>
      </section>

      <section className="py-20 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading text-slate-900 mb-12 text-center">Features for Businesses</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: <BarChart className="w-8 h-8" />, title: 'Multi-User Access', desc: 'Team roles and permissions' },
              { icon: <Shield className="w-8 h-8" />, title: 'Higher Limits', desc: 'Up to ₦50M daily' },
              { icon: <Users className="w-8 h-8" />, title: 'Bulk Payments', desc: 'Pay staff and suppliers easily' },
              { icon: <Building2 className="w-8 h-8" />, title: 'Invoicing', desc: 'Create and send invoices' }
            ].map((feature, idx) => (
              <div key={idx} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 text-center">
                <div className="w-16 h-16 rounded-2xl bg-blue-100 text-brand-blue flex items-center justify-center mx-auto mb-4">
                  {feature.icon}
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2">{feature.title}</h3>
                <p className="text-slate-600 text-sm">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-4 md:px-8 bg-gradient-to-br from-blue-600 to-blue-700 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold font-heading mb-6">Open Your Business Account</h2>
          <p className="text-xl text-blue-100 mb-8">
            Get started in 10 minutes with CAC documents and director's ID
          </p>
          <Button 
            onClick={() => navigate('/contact')}
            className="bg-white text-brand-blue hover:bg-indigo-50 rounded-full px-10 py-6 text-lg font-semibold"
          >
            Apply Now
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
